import * as moment from 'moment';
import { Injectable } from "@angular/core";

@Injectable()
export class Utilidades {
  // Convierte la cadena string de la fecha en timespan
  public static convertDateToUnix(value: string): number {
    return moment(value, 'DD/MM/YYYY').unix();
  }

  public static isNotEmpty(value: string): boolean {
    return value !== undefined && value !== null && value !== '';
  }

  public static convertUnixToDate(unixTime: number): Date {
    const d = new Date(0);
    d.setUTCSeconds(unixTime);
    return d;
  }

  public static getDateString(): string {
    const today = new Date();
    return Utilidades.toSpanishFormatDate(today);
  }

  public static toSpanishFormatDate(date: Date): string {
    return this.formatDate(date, false);
  }

  public static toISOFormatDate(date: Date): string {
    return this.formatDate(date, true);
  }

  private static formatDate(date: Date, isIso: boolean) {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // January is 0!
    const yyyy = date.getFullYear();
    if (isIso)
      return `${yyyy}-${mm}-${dd}`;

    return `${dd}/${mm}/${yyyy}`;
  }

  public static isOfType = <T>(
    varToBeChecked: any,
    propertyToCheckFor: keyof T
  ): varToBeChecked is T =>
    (varToBeChecked as T)[propertyToCheckFor] !== undefined

  public static isString(x: any): x is string {
    return typeof x === 'string';
  }

  public static stringIsNumber(value): boolean {
    return isNaN(Number(value)) === false;
  }

  public static isDate(date: any) {
    if (isNaN(date) && !isNaN(Date.parse(date)))
      return true;
    else return false;
  }

  public static enumToArray(enumeration: any): { key: string | number; value: string; }[] {
    const map = new Map<string, string | number>();
    for (const key in enumeration) {
      if (!isNaN(Number(key))) {
        continue;
      }

      const val = enumeration[key] as string | number;

      if (val !== undefined && val !== null) {
        map.set(key, val);
      }
    }

    return Array.from(map.entries()).map(m => ({ key: m[1], value: m[0] }));
  }

  public static round(value: number, decimals: number): number {
    if (typeof value !== 'number') {
      throw new Error('El valor debe ser numérico.');
    }
    return parseFloat(value.toFixed(decimals));
  }

  public static groupBy(array, key) {
    return array.reduce((result, currentValue) => {
      (result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
      return result;
    }, {});
  }
  public static mapGroupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  public static leapYear(year): boolean {
    return ((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0);
  }

}
